// extracted by mini-css-extract-plugin
module.exports = {"riverSeries":"SeriesType_riverSeries__cAG0h","fadeIn":"SeriesType_fadeIn__ym7ak","fadeOut":"SeriesType_fadeOut__fZR0N"};